export class RemindPassword {
    static readonly type = 'RemindPassword';
    constructor(public username: string, public appname: string) { }
}

export class RemindPasswordSuccess {
    static readonly type = 'RemindPasswordSuccess';
    constructor(public payload: any) { }
}
